
import { Component, Vue } from 'vue-property-decorator'

import { Card } from '@/types/Card'
import cardModule from '@/store/card'

import CardEditor from '@/components/company/card/CardEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'CardList',
  components: {
    CardEditor,
    ContentList
  }
})
class CardList extends Vue {
  private showCardDetail = false
  private listType = ListType

  private get storeModule() {
    return cardModule
  }

  private get cards(): Card[] {
    return cardModule.cards
  }

  private get headers() {
    return [
      { text: 'Titel', value: 'title_big' },
      { text: 'Typ', value: 'type' }
    ]
  }

  private setCard(card: Card): void {
    cardModule.setCard(card)
    ;(this.$refs.cardDialog as any).toggleDialog()
  }
}

export default CardList
